import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Accordion from 'react-bootstrap/Accordion'
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from 'react-bootstrap/Dropdown'
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCopy, FiInfo } from 'react-icons/fi'
import { BsTrash } from 'react-icons/bs'
import './index.css'
import {
    SaveEvent,
    GetLeagues,
    EditLeague,
    DeleteLeague,
    GetEvents,
    CreateSnapshot,
    GetRiders,
    DeleteAllSnapshots,
    GetSnapshots,
    DeleteSnapshotsByName,
    AddResult,
    AddRider,
    UpdateDisabled,
    CreateDisabled,
    GetDisabled,
    SyncLeaderboard
} from '../../../ApiRampageRequests'
import { GetUser, MakeAdmin, GetAllUsers, DeleteUser } from '../../../ApiRequests'
import Cookies from 'universal-cookie'
import cookieUtils from "../../../Utilities/CookieUtils";



const RampageAdmin = (props) => {

    const cookies = new Cookies()
    const cookie = cookies.get('jwt')
    const { scope, userId } = cookieUtils.getScopeFromJWT(cookie)

    const navigate = useNavigate()
    const [leagues, setLeagues] = useState([])
    const [userTeams, setUserTeams] = useState([])
    const [user, setUser] = useState([])
    const [deleteUser, setDeleteUser] = useState({})
    const [showDeleteUser, setShowDeleteUser] = useState(false)
    const [users, setUsers] = useState([])
    const [showAddEvent, setShowAddEvent] = useState(false)
    const [showRemoveEvent, setShowRemoveEvent] = useState(false)
    const [eventLocation, setEventLocation] = useState('')
    const [eventDate, setEventDate] = useState(new Date().toLocaleDateString('en-US', { timeZone: 'UTC' }))
    const [eventDiscipline, setEventDiscipline] = useState('')
    const [showDeleteLeague, setShowDeleteLeague] = useState(false)
    const [privateLeague, setPrivateLeague] = useState('')
    const [showEditLeague, setShowEditLeague] = useState(false)
    const [leagueId, setLeagueId] = useState('')
    const [description, setDescription] = useState('')
    const [copied, setCopied] = useState(false)
    const [featured, setFeatured] = useState(false)
    const [showTakeSnapshot, setShowTakeSnapshot] = useState(false)
    const [events, setEvents] = useState([])
    const [event, setEvent] = useState({})
    const [riders, setRiders] = useState([])
    const [filteredRiders, setFilteredRiders] = useState([])
    const [snapshotName, setSnapshotName] = useState('')
    const [showViewSnapshots, setShowViewSnapshots] = useState(false)
    const [snapshots, setSnapshots] = useState([])
    const [snapshotNames, setSnapshotNames] = useState([])
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [riderCountry, setRiderCountry] = useState('')
    const [riderGender, setRiderGender] = useState('')
    const [riderDOB, setRiderDOB] = useState('')
    const [editingDisabled, setEditingDisabled] = useState(true)

    const [uploadGender, setUploadGender] = useState('Male')
    const [uploadRace, setUploadRace] = useState('Finals')


    const [riderResult, setRiderResult] = useState(0)
    const [rankFilter, setRankFilter] = useState('Name')
    const [genderFilter, setGenderFilter] = useState('All')
    const [showSaveResult, setShowSaveResult] = useState(false)

    const [selectedFile, setSelectedFile] = useState(null);


    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const _user = await GetUser(userId)
        if (!_user) { return }
        if (!'data' in _user) { return }

        setUser(_user.data)
        return _user
    }

    const getAllUsers = async () => {
        const _users = await GetAllUsers()
        if (!_users) { return }

        setUsers(_users)
    }

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }


    const syncLeaderboard = async () => {
        const res = await SyncLeaderboard();
        if (res) {
            console.log(res)
        }
    }

    const JoinGlobalLeague = () => {
        navigate('/CreateTeam?leagueId=645e65fcd95fdd3acdbdcda6')
    }

    const goToLeague = (id) => {
        navigate(`/League?leagueId=${id}`)
    }

    const editMyTeam = (teamId, leagueId) => {
        navigate(`/EditTeam?teamId=${teamId}&leagueId=${leagueId}`)
    }

    const saveEvent = async () => {
        const _event = { date: eventDate, location: eventLocation, discipline: eventDiscipline }
        const res = await SaveEvent(_event)
        if (!res) { console.log('could not save'); return }

        setShowAddEvent(false)
        // navigate('/Events')
    }


    const takeSnapshot = async (eventId) => {
        console.log("taking snapshot of event: ", eventId)

        const res = await CreateSnapshot(eventId, snapshotName)
        // console.log(res)
    }

    const makeAdmin = async (userId, scope) => {
        const res = await MakeAdmin(userId, scope)
        if (res) {
            getAllUsers()
        }
    }

    const editLeague = async () => {
        const data = {
            description: description,
            private: privateLeague,
            leagueId: leagueId,
            featured: featured,
        }

        const res = await EditLeague(data, userId)

        if (res) {
            await getLeagues()
            setShowEditLeague(false)
        }
    }

    const deleteUserConfirm = async () => {
        console.log("DELETING USER", deleteUser)
        try {
            const res = await DeleteUser(deleteUser)
            setShowDeleteUser(false)
            setDeleteUser()
            getAllUsers()
        } catch (err) {
            setShowDeleteUser(false)
        }
    }

    const getEvents = async () => {
        const _events = await GetEvents()
        console.log(_events)
        if (_events) {
            setEvents(_events.data)
        }

    }

    const deleteLeague = async () => {
        const res = await DeleteLeague(leagueId)

        if (res) {
            await getLeagues()
            setShowDeleteLeague(false)
        }
        console.log("Could not delete league", leagueId)
    }


    const getLeagues = async () => {
        const response = await GetLeagues()
        if (response == null) { return }
        setLeagues(response.data)
    }


    const copyURL = async (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 5000);
            })
            .catch((error) => {
                console.error('Failed to copy URL:', error);
            });
    }

    const getRiders = async () => {
        const res = await GetRiders()

        if (res && res.data) {

            const newRiders = res.data.map((rider) => ({
                first_name: rider.first_name,
                last_name: rider.last_name,
                _id: rider._id,
                gender: rider.gender,
                qualifying_points: 0,
                semis_points: 0,
                finals_points: 0,
                total_points: 0
            }))

            const sortedRiders = newRiders.sort((a, b) => a.last_name.localeCompare(b.last_name));
            setRiders(sortedRiders)
            setFilteredRiders(sortedRiders)
        }

    }

    const deleteAllSnapshots = async () => {
        try {
            const res = await DeleteAllSnapshots()
        } catch (error) {
            console.log(error)
        }
    }

    const deleteSnapshot = async (_name) => {
        try {
            const res = await DeleteSnapshotsByName(_name)
            if (res == null) { return }
            getSnapshots()
        } catch (error) {
            console.log(error)
        }
    }

    const getSnapshots = async () => {
        try {
            const res = await GetSnapshots()
            if (res == null) { return }

            setSnapshots(res.data)
            const uniqueNames = [...new Set(res.data.map(snapshot => snapshot.name))];
            setSnapshotNames(uniqueNames)

        } catch (error) {
            console.log(error)
        }
    }

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleAddRider = async () => {
        const res = await AddRider(
            {
                first_name: firstName,
                last_name: lastName,
                DOB: riderDOB,
                country: riderCountry,
                gender: riderGender,
            }
        )

        if (res) {
            setFirstName('')
            setLastName('')
            setRiderCountry('')
            setRiderGender('')
            setRiderDOB('')
        }
    }

    const handleFilter = (genderValue, rankValue) => {
        setGenderFilter(genderValue)
        setRankFilter(rankValue)
        const genderFilter = genderValue === 'Male' ? 'm' : 'f';
        const filtered = riders.filter((rider) => {
            const isGenderMatch = genderValue === 'All' || rider.gender === genderFilter;
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]

        if (rankValue == 'Qualifying') {
            console.log("qualifying")
            filteredAndSortedRiders.sort((a, b) => b?.qualifying_points - a?.qualifying_points);
        } else if (rankValue == 'Semis') {
            console.log("semis")
            filteredAndSortedRiders.sort((a, b) => b?.semis_points - a?.semis_points);
        } else if (rankValue == 'Finals') {
            console.log("finals")
            filteredAndSortedRiders.sort((a, b) => b?.finals_points - a?.finals_points);
        } else if (rankValue == 'Overall') {
            console.log("overall")
            filteredAndSortedRiders.sort((a, b) => (b?.qualifying_points + b?.semis_points + b?.finals_points) - (a?.qualifying_points + a?.semis_points + a?.finals_points));
        } else {
            filteredAndSortedRiders.sort((a, b) => a?.last_name - b?.last_name)
        }

        setFilteredRiders(filteredAndSortedRiders);
    }

    const handleRankChange = (index, e, level) => {
        const updatedRiders = [...filteredRiders]
        updatedRiders[index].total_points = parseFloat(e.target.value)

        setFilteredRiders(updatedRiders)
    }

    const saveEventResult = async () => {

        //Save results. If there are no results, do not save
        console.log(filteredRiders[0])
        const results = filteredRiders
            .filter(
                (rider) =>
                    (rider.total_points !== undefined && rider.total_points !== 0) 
            )
            .map((rider) => ({
                eventId: event._id,
                riderId: rider._id,
                rider_first_name: rider.first_name,
                rider_last_name: rider.last_name,
                total_points: rider.total_points || 0,
                rider_gender: rider.gender
            }));


        console.log('results', results)
        const res = await AddResult(results)
    }

    const handleDisableEditing = async () => {
        const res = await CreateDisabled()
    }

    const handleChangeEditingDisabled = async () => {
        const res = await UpdateDisabled(!editingDisabled)
        getEditingDisabled()
    }

    useEffect(() => {
        getAllUsers()
        getLeagues()
        getEvents()
        getRiders()
        getSnapshots()
        getEditingDisabled()
    }, []);

    const renderEvents = (_event, index) => {
        return (
            <>
                <Card className="my-2 py-0">
                    <Card.Body>
                        <div className="row my-0">
                            <div className="col-md-4 fw-light">{_event?.location}</div>
                            <div className="col-md-4 fw-light">{_event?.date}</div>
                            <div className="col-md-4 d-flex flex-row justify-content-end" >
                                <Button variant='outline-success' className="me-3" onClick={() => { takeSnapshot(_event._id) }}>Take Snapshot</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </>
        )
    }

    const renderSnapshots = (_name, index) => {
        return (
            <>
                <Card className="my-2 py-0">
                    <Card.Body>
                        <div className="row my-0">
                            <div className="col-md fw-light">{_name}</div>
                            <div className="col-md d-flex flex-row justify-content-end" >
                                <Button variant='outline-danger' className="me-3" onClick={() => { deleteSnapshot(_name) }}>Delete Snapshot</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </>)
    }


    const renderRiders = (rider, index) => {
        return (<>
            {
                <Card className="my-1 py-0">
                    <Card.Body className="my-0 py-1">
                        <div className="row my-0">
                            <div className="col-md-2 fw-light">{rider?.first_name} <b>{rider?.last_name}</b></div>
                            <div className="col-md-2"><Form.Control className="col-md-2" type='number' value={rider.total_points} onChange={(e) => (handleRankChange(index, e, 'total_points'))}></Form.Control></div>
                        </div>
                    </Card.Body>
                </Card>
            }
        </>)
    }

    const renderEventsDropdown = (_event, index) => {
        return (
            <>
                <Dropdown.Item value={_event?.date} onClick={(e) => setEvent(_event)}>{_event.date}</Dropdown.Item>
            </>)
    }

    const renderUsers = (_user, index) => {
        return (<>
            {userId != _user._id &&
                <Card className="my-1 py-0">
                    <Card.Body className="">
                        <div className="row my-0">
                            <div className="col-md-4 fw-light">{_user?.userName}</div>
                            <div className="col-md-4 fw-light">{_user?.scope}</div>
                            <div className="col-md-4 d-flex flex-row justify-content-end" >
                                <Button variant='outline-danger' className="me-3" onClick={() => { setDeleteUser(_user); setShowDeleteUser(true) }}>Delete</Button>
                                <div className="w-50">
                                    {_user?.scope == 'admin' ? <Button variant="primary" onClick={() => makeAdmin(_user._id, 'user')}>Make User</Button> : <Button variant="secondary" onClick={() => makeAdmin(_user._id, 'admin')}>Make Admin</Button>}
                                </div>

                            </div>
                        </div>
                    </Card.Body>
                </Card>}
        </>
        )
    }

    const renderLeagues = (league, index) => {
        return (

            <div className="" key={index}>
                <Card className="mx-3 my-4">
                    <Card.Header as="h5">
                        <div className="row">
                            <div className="col-md-9">
                                {league.name}
                            </div>
                            <div className="col-md-3 d-flex flex-row justify-content-end">
                                <FiEdit className="me-3 hover-pointer" onClick={() => { setShowEditLeague(true); setLeagueId(league?._id); setDescription(league?.description); setPrivateLeague(league?.private); setFeatured(league?.featured) }}></FiEdit>
                                <BsTrash className="me-3 hover-pointer" onClick={() => { setShowDeleteLeague(true); setLeagueId(league?._id) }}></BsTrash>
                            </div>
                        </div>

                    </Card.Header>
                    <Card.Body>
                        {league && 'private' in league && league.private &&
                            <div className="my-2">
                                <Form.Label className="mt-1 fw-bold">League Url:</Form.Label>
                                <div className="row">
                                    <div className="col-md"> <Form.Control type='text' disabled className='fw-light' readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                    <div className="col-md-2 py-2 py-sm-0">
                                        <Button variant="secondary" onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}><FiCopy></FiCopy> Copy URL</Button>
                                    </div>
                                </div>

                            </div>}
                        <div className="">{league.description}</div>
                    </Card.Body>
                </Card>
            </div >
        )
    }

    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            {scope == 'admin' ?
                <>
                    <div className="py-3">
                        <Card>
                            <Card.Header as="h5" className="py-3">Functions:</Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-3">
                                        <Form.Label>Disabled Editing</Form.Label>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label={`${editingDisabled ? 'disabled' : 'enabled'}`}
                                            onChange={() => handleChangeEditingDisabled()}
                                        />
                                    </div>
                                    <div className="col">
                                        <Button variant='warning' onClick={() => syncLeaderboard()}>Sync Leaderboards</Button>
                                    </div>
                                    <div className="col">
                                        <Button variant='warning' disabled onClick={() => CreateDisabled()}>Create Disabled</Button>
                                    </div>
                                </div>



                                {/* <Button onClick={handleDisableEditing}>Create</Button> */}
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="py-3">
                        <Card>
                            <Card.Header as="h5" className="py-3">Add Rampage Event</Card.Header>
                            <Card.Body>
                                <Card.Title className="px-3 py-2">Add or delete an event from the calendar</Card.Title>
                                <Button variant="warning" className="mx-3 my-2" onClick={() => setShowAddEvent(true)}>Add Event</Button>
                                <Button variant="outline-danger" className="mx-3 my-2" onClick={() => setShowRemoveEvent(true)}> Delete Event</Button>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="py-3">
                        <Card>
                            <Card.Header as="h5" className="py-3">Take Rampage snapshot</Card.Header>
                            <Card.Body>
                                <Card.Title className="px-3 py-2">Add or delete an event from the calendar</Card.Title>
                                <Button variant="warning" className="mx-3 my-2" onClick={() => setShowTakeSnapshot(true)}>Take Snapshot</Button>
                                <Button variant="outline-warning" className="mx-3 my-2" onClick={() => setShowViewSnapshots(true)}>View Snapshots</Button>
                                <Button variant="danger" disabled className="mx-3 my-2" onClick={() => deleteAllSnapshots()}>Delete All Snapshots</Button>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className="py-3">
                        <Card>
                            <Card.Header as="h5" className="py-3">Add Rider</Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-sm">first name</div>
                                    <div className="col-sm">last name</div>
                                    <div className="col-sm">country</div>
                                    <div className="col-sm">DOB</div>
                                    <div className="col-sm">gender</div>
                                </div>

                                <div className="row">
                                    <div className="col-sm">
                                        <Form.Control type="text" placeholder="First Name" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} />
                                    </div>
                                    <div className="col-sm">
                                        <Form.Control type="text" placeholder="Last Name" value={lastName} onChange={(e) => { setLastName(e.target.value) }} />
                                    </div>
                                    <div className="col-sm">
                                        <Form.Control type="text" placeholder="Country" value={riderCountry} onChange={(e) => { setRiderCountry(e.target.value) }} />
                                    </div>
                                    <div className="col-sm">
                                        <Form.Control type="text" placeholder="Value" value={riderDOB} onChange={(e) => { setRiderDOB(e.target.value) }} />
                                    </div>
                                    <div className="col-sm">
                                        <Form.Control type="text" placeholder="Gender" value={riderGender} onChange={(e) => { setRiderGender(e.target.value) }} />
                                    </div>

                                </div>

                                <Button className='my-3 px-4' variant="warning" onClick={() => handleAddRider()}>Add Rider</Button>

                            </Card.Body>
                        </Card>
                    </div>


                    <Accordion className="my-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Add Result</Accordion.Header>
                            <Accordion.Body>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <DropdownButton id="dropdown-basic-button" variant='outline-secondary' title={event?.date} className="">
                                            {Array.isArray(events) && events.map(renderEventsDropdown)}
                                        </DropdownButton>
                                    </div>
                                    <div className="col-sm d-flex justify-content-end">
                                        <Button variant="primary w-25" onClick={() => setShowSaveResult(true)}>Save</Button>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-2 d-flex justify-content-center">Score</div>
                                </div>
                                {Array.isArray(filteredRiders) && filteredRiders.map(renderRiders)}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Accordion className="my-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Leagues {leagues?.length}</Accordion.Header>
                            <Accordion.Body>
                                {<div className="py-4">
                                    {Array.isArray(leagues) && leagues.map(renderLeagues)}
                                </div>}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Accordion className="my-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Users {users?.length}</Accordion.Header>
                            <Accordion.Body>
                                {users.map(renderUsers)}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                </>
                : <div className="">Unauthorized</div>}



            <Modal show={showAddEvent} onHide={() => setShowAddEvent(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Location</Form.Label>
                    <Form.Control type="text" placeholder="Location" value={eventLocation} onChange={(e) => { setEventLocation(e.target.value) }} />
                    <br />
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" value={eventDate} onChange={(e) => setEventDate(e.target.value)} />
                    <br />
                    <Form.Label>Discipline</Form.Label>
                    <Form.Control type="text" placeholder="Discipline" value={eventDiscipline} onChange={(e) => setEventDiscipline(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddEvent(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => saveEvent()}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showRemoveEvent} onHide={() => setShowRemoveEvent(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Remove Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemoveEvent(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => setShowRemoveEvent(false)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteUser} onHide={() => setShowDeleteUser(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete User: {deleteUser?.userName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {deleteUser?.userName}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteUser(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => deleteUserConfirm()}>
                        Delete User
                    </Button>
                </Modal.Footer>
            </Modal>




            <Modal show={showEditLeague} onHide={() => setShowEditLeague(false)}>
                <Modal.Header closeButton>
                    <FiEdit size={24} className="me-2"></FiEdit>
                    <Modal.Title>Edit League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" value={description} placeholder='Describe your league...' onChange={(e) => setDescription(e.target.value)} />

                    <Form.Label className="mt-4">Feature League?</Form.Label>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={`${featured ? 'featured' : 'Not Featured'}`}
                        onChange={() => setFeatured(!featured)}
                    />

                    <Form.Label className="mt-4">League Privacy Setting:</Form.Label>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={`${privateLeague ? 'private' : 'public'}`}
                        onChange={() => setPrivateLeague(!privateLeague)}
                    />

                    {privateLeague &&
                        <>
                            <Form.Label className="mt-4">Private League URL:</Form.Label>
                            <div className="row">
                                <div className="col-md"> <Form.Control type='text' className="fw-light" disabled readOnly value={`${URL}/Login?leagueId=${leagueId}`} ></Form.Control></div>
                                <div className="col-md-4 py-2 py-sm-0">
                                    <Button variant="secondary" className='' onClick={() => copyURL(`${URL}/Login?leagueId=${leagueId}`)}><FiCopy></FiCopy> Copy URL</Button>
                                </div>
                            </div>
                        </>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditLeague(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => editLeague()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteLeague} onHide={() => setShowDeleteLeague(false)}>
                <Modal.Header closeButton>
                    <BsTrash size={24} className="me-2"></BsTrash>
                    <Modal.Title>Delete League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Are you sure you want to delete this league? </Form.Label>
                    <Form.Label>Deleting a league is permanent and the league cannot be recovered. </Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteLeague(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => deleteLeague()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='lg' show={showTakeSnapshot} onHide={() => setShowTakeSnapshot(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Take Snapshot</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Snapshot Name </Form.Label>
                    <Form.Control type='text' className='fw-light' value={snapshotName} onChange={(e) => setSnapshotName(e.target.value)}></Form.Control>
                    <Form.Label>Take snapshot for which event? </Form.Label>
                    {Array.isArray(events) && events.map(renderEvents)}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowTakeSnapshot(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='lg' show={showViewSnapshots} onHide={() => setShowViewSnapshots(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>View Snapshots</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {Array.isArray(snapshotNames) && snapshotNames.map(renderSnapshots)}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowViewSnapshots(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal size='md' show={showSaveResult} onHide={() => setShowSaveResult(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Save Result</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Event: {event.location}</Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowSaveResult(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => saveEventResult()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>

    );
}

export default RampageAdmin;